import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core";

export const styles = ({ spacing }: Theme) => createStyles({
    item: {
        display: "inline-flex",
        alignItems: "flex-start"
    },
    list: {
        columnCount: 2,
        columnFill: "balance"
    }
});


// WEBPACK FOOTER //
// ./src/components/ListIcon/ListIcon.style.tsx